import React, { ReactNode } from 'react';
import { Link as GatsbyLink } from 'gatsby-link';
import styled from 'styled-components';

import { DEQ_TYPES } from '../../../utils/deq';
import { isExternalUrl } from '../../../utils/string-utils/string-utils';

interface Props {
  id?: string;
  trackingLabel: string;
  trackingType?: string;
  trackingComponent?: string;
  href: string;
  children: ReactNode;
  className?: string;
  customClick?: () => void;
  elementPosition?: number;
}

const Link = ({
  id,
  trackingLabel,
  trackingType,
  trackingComponent,
  href,
  children,
  className,
  customClick,
  elementPosition,
  ...props
}: Props) => {
  if (isExternalUrl(href)) {
    return (
      <AnchorLink
        id={id}
        data-component-type={trackingComponent?.toLowerCase()}
        data-element-type={trackingType || DEQ_TYPES.btnLink}
        data-element-label={`${trackingLabel}`.toLowerCase()}
        data-element-target={href}
        data-element-position={elementPosition}
        href={href}
        className={className}
        target="_blank"
        onClick={customClick && customClick}
        {...props}
      >
        {children}
      </AnchorLink>
    );
  }

  return (
    <StyledGatsbyLink
      id={id}
      data-component-type={trackingComponent?.toLowerCase()}
      data-element-type={trackingType || DEQ_TYPES.btnLink}
      data-element-label={`${trackingLabel}`.toLowerCase()}
      data-element-target={href}
      data-element-position={elementPosition}
      to={href}
      target="_self"
      className={className}
      onClick={customClick && customClick}
      {...props}
    >
      {children}
    </StyledGatsbyLink>
  );
};

export default Link;

const StyledGatsbyLink = styled(GatsbyLink)`
  text-decoration: none;
`;

const AnchorLink = styled.a`
  text-decoration: none;
`;
